import React from 'react';
import PropTypes from 'prop-types';
import YellowGreenButton from './YellowGreenButton';
import SlotInfo from './SlotInfo';
import CoachInfo from './CoachInfo';
import i18n from '../utils/i18n';
import { formatDateForSessionCard } from '../utils/other';
import {
  disableBookStatuses,
  bookingAvailabilityStatusesMessages
} from '../utils/constants';
import './styles/SessionSlotCard.scss';

const MAX_SHOW_SLOTS_NUMBER = 3;

class SessionSlotCard extends React.Component {
  getDisplayedButtonText() {
    const {
      available_spaces: availableSpaces,
      booking_availability_status: bookingAvailabilityStatus
    } = this.props.event;

    const bookingDisabled =
      disableBookStatuses.indexOf(bookingAvailabilityStatus) !== -1;
    let displayedButtonText = '';

    if (!bookingDisabled) {
      displayedButtonText = i18n.t('singleSessionScreen.BOOK_SLOT');
    } else if (availableSpaces <= MAX_SHOW_SLOTS_NUMBER) {
      const slotLeft =
        availableSpaces === 1
          ? i18n.t('singleSessionScreen.SLOT_LEFT')
          : i18n.t('singleSessionScreen.SLOTS_LEFT');
      displayedButtonText = `${i18n.t(
        'singleSessionScreen.BOOK'
      )} - ${availableSpaces} ${slotLeft}`;
    } else {
      displayedButtonText = bookingAvailabilityStatusesMessages[bookingAvailabilityStatus]
    }

    return displayedButtonText;
  }

  render() {
    const {
      event_date: eventDate,
      start_time: startTime,
      venue_club_name: clubName,
      venue_address: clubAddress,
      coach_name: coachName,
      coach_pic: coachPicture,
      booking_availability_status: bookingAvailabilityStatus
    } = this.props.event;

    const displayedButtonText = this.getDisplayedButtonText();
    const bookingDisabled =
      disableBookStatuses.indexOf(bookingAvailabilityStatus) !== -1;

    return (
      <div className="event-card-component">
        <div
          className={ `event-card ${this.props.pendingBooking &&
            'pending-booking-card'}` }
        >
          <SlotInfo
            date={ formatDateForSessionCard(startTime, eventDate) }
            clubName={ clubName }
            address={ clubAddress }
          />
          <CoachInfo name={ coachName } picture={ coachPicture } />
          <hr />
          {!this.props.pendingBooking ? (
            <YellowGreenButton
              onClick={ this.props.startQuickBooking }
              text={ displayedButtonText }
              buttonClass={ bookingDisabled ? 'disabled-button' : '' }
              disabled={ bookingDisabled }
              style={ {
                width: '200px',
                marginTop: '20px'
              } }
            />
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

SessionSlotCard.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    available_spaces: PropTypes.number,
    event_date: PropTypes.string,
    start_time: PropTypes.string,
    venue_club_name: PropTypes.string,
    venue_address: PropTypes.string,
    coach_name: PropTypes.string,
    coach_pic: PropTypes.string,
    remaining_limit_for_user: PropTypes.number
  }),
  startQuickBooking: PropTypes.func,
  pendingBooking: PropTypes.bool
};

SessionSlotCard.defaultProps = {
  event: {
    id: null,
    available_spaces: 0,
    event_date: '',
    start_time: '',
    venue_club_name: '',
    venue_address: '',
    coach_name: '',
    coach_pic: '',
    remaining_limit_for_user: 0
  },
  startQuickBooking: () => {},
  pendingBooking: false
};

export default SessionSlotCard;



// WEBPACK FOOTER //
// ./src/components/SessionSlotCard.js